import { NestedKeys } from "./HelperTypes";
import {
  Company,
  IAsset,
  IGroup,
  IOrganizationUnit,
  IRoom,
  SimpleUser,
} from "./NendaTypes";

interface ISort<T, SortableFields extends keyof T> {
  sortBy: SortableFields;
  sortOrder: "asc" | "desc";
}

interface IPagination {
  page: number;
  pageSize: number;
}

export type IFilter<T> = {
  [K in keyof T]?: T[K];
};

export interface IListRequest<T, SortableFields extends keyof T> {
  pagination?: IPagination;
  filter?: IFilter<T>;
  sort?: ISort<T, SortableFields>;
}

export interface IListResponse<T> {
  data: T[];
  totalCount: number;
  filteredCount: number;
  page: number;
  pageSize: number;
}
export type PatchRequest<T> = {
  data: Partial<T>;
  unsetFields?: NestedKeys<T>[];
};

export enum UserSortableFields {
  EMAIL = "email",
  TYPE = "type",
}

export type IUserListRequest = IListRequest<SimpleUser, UserSortableFields>;

export enum CompanySortableFields {
  NAME = "name",
}

export type ICompanyListRequest = IListRequest<Company, CompanySortableFields>;

export enum RoomSortableFields {
  HOTEL = "hotel",
}

export enum AssetSortableFields {
  NAME = "name",
  CREATED_AT = "createdAt",
}
export type IAssetListRequest = IListRequest<IAsset, AssetSortableFields>;

export type IRoomListRequest = IListRequest<IRoom, RoomSortableFields>;

export enum OrganizationUnitSortableFields {
  PARENT = "parent",
  NAME = "name",
}

export type IOrganizationUnitListRequest = IListRequest<
  IOrganizationUnit,
  OrganizationUnitSortableFields
>;

export type GroupProps = Omit<IGroup, "company" | "premise" | "_id">;
